import React from 'react';
import {Box, Avatar, Menu, MenuItem} from '@mui/material';
import {useAuthMethod, useAuthUser} from '@crema/hooks/AuthHooks';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {Fonts} from '@crema/constants/AppEnums';
import {useNavigate} from 'react-router-dom';

type UserInfoProps = {
  color?: string;
};

const UserInfo: React.FC<UserInfoProps> = ({color = 'text.secondary'}) => {
  const {logout} = useAuthMethod();
  const {user} = useAuthUser();
  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Box
        onClick={handleClick}
        sx={{
          py: 3,
          px: 3,
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
        }}
        className='user-info-view'
      >
        <Box sx={{py: 0.5}}>
          {user?.profileImage ? (
            <Avatar
              sx={{
                width: {xs: 30, lg: 45},
                height: {xs: 30, lg: 45},
                cursor: 'pointer',
              }}
              src={user?.profileImage}
            />
          ) : (
            <Avatar
              sx={{
                width: {xs: 30, lg: 45},
                height: {xs: 30, lg: 45},
                fontSize: 24,
                backgroundColor: '#339966',
              }}
            >
              {user?.name?.charAt(0).toUpperCase()}
            </Avatar>
          )}
        </Box>
        <Box
          sx={{
            width: {xs: 'calc(100% - 62px)', xl: 'calc(100% - 72px)'},
            ml: 4,
            color: color,
          }}
          className='user-info'
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 3,
            }}
          >
            <Box
              sx={{
                mb: 0,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                fontSize: 16,
                fontWeight: Fonts.MEDIUM,
                color: 'inherit',
              }}
            >
              {user?.name || 'Admin'}
            </Box>
            <ExpandMoreIcon />
          </Box>
          <Box
            sx={{
              mt: -0.5,
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              color: 'inherit',
            }}
          >
            {user?.description}
          </Box>
        </Box>
      </Box>
      <Menu
        id='simple-menu'
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem
          onClick={() => {
            handleClose();
            navigate('/account');
          }}
        >
          My account
        </MenuItem>
        <MenuItem onClick={logout}>Logout</MenuItem>
      </Menu>
    </>
  );
};

export default UserInfo;
